
export default function Merits() {
  const merits = [
    {
      icon: 'ri-flashlight-line',
      title: '最短5分でカード番号発行！すぐに使える',
      description: 'スピード発番「スピ発」に対応しており、オンライン申込から最短5分でカード番号が発行されます。カード会社公式アプリでカード番号をすぐに確認でき、ネットショッピングやスマホ決済（Apple Pay・Google Pay）ですぐに利用可能。プラスチックカードの到着を待たずに使い始められるので、急ぎでカードが必要な方に最適です。',
      highlight: 'スピード発番なら初年度年会費無料！',
    },
    {
      icon: 'ri-shield-check-line',
      title: '充実の付帯保険で安心',
      description: '国内・海外旅行傷害保険が最高3,000万円付帯。さらにスマートフォン保険（年間最高30,000円、自己負担10,000円）も付いており、スマホの画面割れなどの修理費用を補償。海外ショッピングガード保険も最高100万円まで補償されるので、海外旅行やネットショッピングも安心して楽しめます。',
      highlight: '一般カードでこの保険内容は非常に充実！',
    },
    {
      icon: 'ri-gift-2-line',
      title: '優待店でポイント最大20倍',
      description: 'カード会社優待店舗でポイントが2〜20倍に！スターバックス、Amazon、セブン-イレブン、ビックカメラなど人気店舗で効率よくポイントが貯まります。貯まったポイントはnanacoポイントやAmazonでの支払いなど、様々な使い道があります。',
      highlight: 'スターバックスでポイント20倍！',
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-[#F8F9FA] to-[#E8F5E9]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-3 text-center">
          地方銀行系スピード発行カードの3つのメリット
        </h2>
        <p className="text-gray-600 text-center mb-12">スピード発行と充実保険が魅力のクレジットカード</p>

        <div className="space-y-6">
          {merits.map((merit, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 md:p-8 hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#00A651] rounded-full flex-shrink-0">
                  <i className={`${merit.icon} text-white text-xl`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3 flex-wrap">
                    <span className="bg-[#003366] text-white text-xs font-bold px-3 py-1 rounded-full">
                      メリット{index + 1}
                    </span>
                    <h3 className="text-lg md:text-xl font-bold text-[#003366]">{merit.title}</h3>
                  </div>
                  <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-3">
                    {merit.description}
                  </p>
                  <div className="bg-[#E8F5E9] border-l-4 border-[#00A651] px-4 py-2 rounded">
                    <p className="text-[#003366] text-xs md:text-sm font-medium">
                      <i className="ri-information-line mr-1"></i>
                      {merit.highlight}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
